module.exports = __webpack_public_path__ + "solanaproject/img/selected.4c7678d5.png";